import logoIntegraSocial from 'assets/logos/integra-social.svg'
import logoCeara from 'assets/logos/logo-gov-ce-white.svg'
import logoutIcon from 'assets/icons/logoutIcon.svg'
import { Device } from 'components/Device'

import './styles.scss'
import { MenuOutlined } from '@ant-design/icons'
import { useEffect, useRef, useState } from 'react'
import { useAuthentication } from 'context/AuthContext'
import { useAccessibility } from 'context/hooks/useAccessibility'

function Header() {
  const [showMenu, setShowMenu] = useState(false)
  const refAreaNav = useRef<HTMLElement>(null)
  const refAreaHamburguer = useRef<HTMLDivElement>(null)
  const { handleLogout } = useAuthentication()
  const { contrastIsSelected } = useAccessibility()

  const device = Device.useDevice()
  const devicePrefix = device.prefix()

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        !(refAreaNav.current?.contains(event.target as Node) ?? false) &&
        !(refAreaHamburguer.current?.contains(event.target as Node) ?? false)
      ) {
        setShowMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [refAreaNav])

  return (
    <header className={devicePrefix} id="container-header">
      <section id="header-content">
        <div id="header-logos">
          <a href="/integrasocial/pesquisa">
            <img src={logoIntegraSocial} alt="Logo Integra Social CE" />
          </a>
          <img src={logoCeara} alt="Logo Governo do Estado do Ceará" />
        </div>
        {(devicePrefix === 'xs' || devicePrefix === 'sm') && (
          <div
            className="header-hamburguer"
            ref={refAreaHamburguer}
            style={{ alignSelf: 'center', margin: '0 20px', cursor: 'pointer' }}
            onClick={() => {
              setShowMenu(!showMenu)
            }}
          >
            <MenuOutlined style={{ color: 'white', fontSize: '24px' }} />
          </div>
        )}
        {(devicePrefix === 'md' || devicePrefix === 'lg' || showMenu) && (
          <nav
            ref={refAreaNav}
            id="header-nav"
            className={`${contrastIsSelected ? 'contrastMode' : ''} ${
              showMenu ? 'opened' : ''
            }`}
          >
            <a
              href={`${process.env.REACT_APP_BIGDATA_URL ?? ''}`}
              className="header-nav-link"
            >
              INÍCIO
            </a>
            <a
              href={`${
                process.env.REACT_APP_BIGDATA_URL ?? ''
              }/dashboard/eixos`}
              className="header-nav-link"
            >
              TERMÔMETRO
            </a>
            <a
              href={`${process.env.REACT_APP_BIGDATA_URL ?? ''}/dashboard/mapa`}
              className="header-nav-link"
            >
              MAPA
            </a>
            <a
              href={`${
                process.env.REACT_APP_BIGDATA_URL ?? ''
              }/dashboard/gestores-acoes`}
              className="header-nav-link"
            >
              AÇÕES
            </a>
            <a
              onClick={handleLogout}
              className="header-nav-link exit-button-background"
            >
              <img src={logoutIcon} alt="Ícone logout" />
              SAIR
            </a>
          </nav>
        )}
      </section>
    </header>
  )
}

export default Header
